export const import_export_card_strings = {
  title: "Import/Export Parts",
  description:
    "Upload CSV files to import parts or download existing parts data",

  // File upload section
  uploadTitle: "Upload CSV File",
  uploadDescription: "Select a CSV file to upload",
  uploadButton: "Upload CSV",
  uploadAcceptedTypes: "CSV files only",
  uploadSuccess: "File uploaded successfully",
  uploadError: "Failed to upload file",

  // Sources table
  sourcesTitle: "Uploaded Sources",
  sourcesEmpty: "No CSV sources uploaded yet",
  filename: "Filename",
  uploadDate: "Upload Date",
  rowsCount: "Rows",
  fileSize: "Size",
  actions: "Actions",
  delete: "Delete",
  download: "Download All Parts",

  // Confirmation dialogs
  deleteConfirmTitle: "Delete Source",
  deleteConfirmMessage:
    "Are you sure you want to delete this CSV source and EVERY ROW associated with it? This action cannot be undone.",
  cancel: "Cancel",
  confirm: "Confirm",

  // Loading states
  loading: "Loading...",
  uploading: "Uploading...",
  deleting: "Deleting...",
  downloading: "Downloading...",

  // Error states
  error: "An error occurred",
  networkError: "Network error occurred",
};
